<template>
    <div id="aps">
        <Form :model="formItem" :disabled="prevent" :label-width="85" label-position="left" style="margin-top:20px">
          <Row> 
            <Col span="5">
              <FormItem label="申请ID">
                <Input v-model="formItem.apply_id" />
              </FormItem>
            </Col>
            <Col span="5" offset="1">
              <FormItem label="申请名称">
                <Input v-model="formItem.apply_name" />
              </FormItem>
            </Col>
            <Col span="1" offset="1">
                  <Button type="primary" @click="getData()">查询</Button>
            </Col>
          </Row>
        </Form>
        <Table
          class="box-margin"
          border
          :columns="columns"
          :loading="prevent"
          :data="data"
          ref="lcTable"
          @on-row-click ="clickRow"
          @on-selection-change="itemClick"
          size="small"
        >
         <template slot-scope="{ row }" slot="applyname">
                    <div v-html="row.apply_name"></div>
                </template>
        </Table>
        <Page v-if="data.length != 0"  @on-change="pageChange" :total="pageInfo.itemCount" show-total />
        <Form :disabled="prevent" style="display: flex;flex-direction: row-reverse;">
            <Button :disabled="!isClick" type="warning" @click="toPage()"> <Icon type="md-options" />流程设定</Button>
        </Form>
    </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
    data() {
        return {
            formItem:{},
            date: new DateUtil(),
            BBList:[],
            prevent: false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1
            },
            columns: [
                {
                type: 'selection',
                width: 60,
                align: 'center'
                },
                // {
                // title: this.$t('ApprovalProcessSetList.edition'),
                // key: "version_id",
                // align: 'center',
                // render: (h, params) => {
                //     var name1 = ''
                //         this.BBList ? this.BBList.map((item,index) => {
                //         if (item.val == params.row.version_id) {
                //             name1 = item.name
                //         }
                //     }) : ''
                //     return h(
                //         "span",
                //     name1
                //     );
                // },
                // },
                {
                title: "申请ID",
                key: "apply_id",
                align: 'center'
                },
                {
                title: "申请名称",
                slot: "applyname",
                align: 'center'
                },
                {
                title: "图标",
                key: "apply_icon",
                width: 60,
                align: 'center',
                render: (h, params) => {
                return h('div', [
                            h('Icon', {
                                props: {
                                    type: params.row.apply_icon,
                                    style: 'font-size: 23px'
                                }
                            }),
                        ]);
                },
                },
                // {
                // title: this.$t('ApprovalProcessSetList.visibleUsers'),
                // key: "auth_user_name",
                // align: 'center'
                // },
                // {
                // title: this.$t('ApprovalProcessSetList.visibleDepartments'),
                // key: "auth_department_name",
                // align: 'center'
                // },
                {
                title: "创建时间",
                key: "created_date",
                align: 'center',
                render: (h, params) => {
                    return h(
                    "span",
                    this.date.dateVal(params.row.created_date, "YYYY/MM/DD HH:mm")
                    );
                },
                },
                {
                title:"创建者",
                key: "created_by",
                align: 'center'
                },
                {
                title: "更新时间",
                key: "updated_date",
                align: 'center',
                render: (h, params) => {
                    return h(
                    "span",
                    this.date.dateVal(params.row.updated_date, "YYYY/MM/DD HH:mm")
                    );
                },
                },
                {
                title: "更新者",
                key: "updated_by",
                align: 'center'
                },
            ],
            data: [{
                version_id: 1
            },
            {
                version_id: 2
            }],
            isClick: false,
            selection: []
        }
    },
    watch: {
        selection(val) {
            this.isClick = false
            if(val.length == 1) {
                this.isClick = true
            }
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        pageChange(val) {
            this.pageInfo.pageNo = val;
            this.getData(1);
            },
        getData(i) {
            if (!i) {
                this.pageInfo={
                    itemCount: 0,
                    pageNo: 1,
                    pageSize: 10,
                }
            }
            this.prevent = true
            let arr = [
                    {
                    "objData1": this.formItem,
                    "objData2": {"pageNo": this.pageInfo.pageNo},
                    "stringData1": "A5A541E7BA29A93237F9D2086C913F33",
                    "stringData2": "93691ABC763FC67F",
                    "stringData3": "3",
                    "type": "P00"
                    }
                    ]
            axios.post("/process/execute", arr).then((res) => {
                this.prevent = false
                if (res) {
                    // this.data = res
                    this.data = res[0].dataList
                    this.pageInfo = res[0].pageInfo
                }
             });
        },
        clickRow(row,index){
             this.$refs.lcTable.toggleSelect(index);
             },
         itemClick(selection) {
             console.log(selection)
                this.selection = selection
             },
        toPage() {
            this.$router.push({
                path: '/A5A541E7BA29A93237F9D2086C913F33/56CEB60557E4058A',
                query: {
                    apply_id: this.selection[0].apply_id
                }
                })
        }
    }
}
</script>
<style  scoped>

</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/ApprovalProcessSetList.vue